import React from 'react';

const ValueCard = ({ value, index }) => {
  return (
    <div 
      className="p-8 lg:p-10 bg-white border border-gray-100 hover:border-sky-200 transition-all duration-500 hover:shadow-xl animate-fade-in-up group"
      style={{ animationDelay: `${index * 100}ms` }}
    >
      <div className="w-12 h-1 bg-sky-500 mb-6 group-hover:w-20 transition-all duration-500" />
      <h3 className="text-xl font-medium text-gray-900 mb-4">
        {value.title}
      </h3>
      <p className="text-gray-600 font-light leading-relaxed">
        {value.description}
      </p>
    </div>
  );
};

export default ValueCard;
